// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, formValueSelector } from 'utils/reduxFormWrapper';
import { connect } from 'react-redux';
import { customRequired } from 'utils/validation';
import Icon from 'shared/components/Icon';
import { payerPlansRequested } from 'shared/actions/PayersActions';
import { SelectInput } from 'shared/containers/portal_layout/HForm';
import { change } from 'utils/reduxFormWrapper';
import styles from './InsuranceCoverageForm.module.scss';

const planRequired = customRequired('Insurance Plan Required');

class InsuranceCoverageForm extends Component {
  componentDidMount() {
    if (this.props.myPayer) {
      this.props.dispatch(payerPlansRequested(this.props.myPayer.id));
    }
  }

  render() {
    const {
      coverage,
      payers,
      myPayer,
      myPlans,
      index,
      remove,
      unlistedPayer,
      selectPayer,
    } = this.props;
    return (
      <div
        className={styles.PatientInsuranceForm}
        id={`insurance-coverage-form-${index}`}
      >
        <section className={styles.insurance_card}>
          <div>
            {index > 0 ? (
              <div className={styles.remove}>
                <button
                  data-spec-class="remove-insurance-button"
                  type="button"
                  className="button is-smaller is-danger is-outlined btn btn-danger btn-mini"
                  onClick={remove}
                >
                  <Icon name="cross" />
                </button>
              </div>
            ) : null}
            <label>
              {['Primary', 'Secondary', 'Tertiary'][index] || 'Additional'}{' '}
              Insurance
            </label>
          </div>
          <div>
            {unlistedPayer ? (
              <Field
                component="input"
                type="text"
                placeholder="payer name"
                className="input input-large"
                name={`${coverage}.unlistedPayerName`}
              />
            ) : (
              <div>
                <SelectInput
                  label="Payer"
                  className="input-xlarge required payer-select"
                  name={`${coverage}.payerId`}
                  options={payers.items}
                  valueKey="id"
                  labelKey="name"
                  isLoading={payers.isFetching}
                  placeholder="Select Payer..."
                  onChange={(payerId) => selectPayer(payerId, coverage)}
                />

                {myPlans.length > 0 ? (
                  <SelectInput
                    className="input-xlarge required plan-select"
                    name={`${coverage}.planId`}
                    valueKey="id"
                    labelKey="name"
                    options={myPlans}
                    isLoading={myPayer.fetchingPlans}
                    placeholder="Select Plan..."
                    validate={planRequired}
                  />
                ) : null}
              </div>
            )}

            <label>
              <span>
                <Field
                  type="checkbox"
                  name={`${coverage}.unlistedPayer`}
                  component="input"
                  normalize={(value) => !!value}
                />{' '}
                Carrier not in list
              </span>
            </label>

            <div className={styles.divider} />

            <label>Insurance Member ID</label>
            <Field
              name={`${coverage}.membershipIdCode`}
              type="text"
              component="input"
              className="input input-large"
              placeholder="Insurance Member ID"
            />
          </div>
        </section>
      </div>
    );
  }
}

InsuranceCoverageForm.propTypes = {
  coverage: PropTypes.string.isRequired,
  payers: PropTypes.object,
  myPayer: PropTypes.object,
  myPlans: PropTypes.array,
  index: PropTypes.number.isRequired,
  remove: PropTypes.func.isRequired,
  unlistedPayer: PropTypes.bool.isRequired,
  selectPayer: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectPayer: (payerId, coverage) => {
    if (payerId) {
      // TODO: I don't like dispatching two separate actions, so I'd
      // like to circle back at some point to do something in reducer-land
      dispatch(payerPlansRequested(payerId));
      dispatch(change(ownProps.form, `${coverage}.planId`, null));
    }
  },
  dispatch,
});

const nullPayer = { plans: [], fetchingPlans: false };

const mapStateToProps = (state, ownProps) => {
  const myValueSelector = formValueSelector(ownProps.form);
  const formValues = myValueSelector(state, ownProps.coverage);
  const myPayer =
    state.payers.items.find((payer) => payer.id === formValues.payerId) ||
    nullPayer;
  return {
    unlistedPayer: formValues.unlistedPayer,
    payers: state.payers,
    myPayer,
    myPlans: myPayer.plans || [],
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsuranceCoverageForm);
